var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Flex, Typography, theme } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
export var SpaceBuffer = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var space = _a.space;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var formatDuration = function (duration) {
        var durationMoment = moment.duration(duration);
        var minutes = durationMoment.asMinutes();
        var hours = Math.floor(minutes / 60);
        var remainingMinutes = minutes % 60;
        if (minutes < 60) {
            return "".concat(minutes, " ").concat(t('buffers.minutes'));
        }
        else {
            var durationString = '';
            durationString += "".concat(hours, " ").concat(t('buffers.hours'));
            if (remainingMinutes > 0) {
                durationString += " ".concat(remainingMinutes, " ").concat(t('buffers.minutes'));
            }
            return durationString;
        }
    };
    if (!((_b = space.buffer) === null || _b === void 0 ? void 0 : _b.before_duration) && !((_c = space.buffer) === null || _c === void 0 ? void 0 : _c.after_duration)) {
        return null;
    }
    return (_jsxs(BufferWrapper, { token: token, children: [_jsx(Typography.Title, { level: 5, style: { marginBottom: 0 }, children: t('buffers.buffer') }), ((_d = space.buffer) === null || _d === void 0 ? void 0 : _d.before_duration) && (_jsxs(Buffer, { children: [_jsx(Typography.Text, { type: "secondary", children: t('buffers.before_event') }), _jsx(Typography.Text, { children: formatDuration((_f = (_e = space.buffer) === null || _e === void 0 ? void 0 : _e.before_duration) !== null && _f !== void 0 ? _f : '') })] })), ((_g = space.buffer) === null || _g === void 0 ? void 0 : _g.after_duration) && (_jsxs(Buffer, { children: [_jsx(Typography.Text, { type: "secondary", children: t('buffers.after_event') }), _jsx(Typography.Text, { children: formatDuration((_j = (_h = space.buffer) === null || _h === void 0 ? void 0 : _h.after_duration) !== null && _j !== void 0 ? _j : '') })] }))] }));
};
var BufferWrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n"], ["\n  border-top: 1px solid ", ";\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n"])), function (_a) {
    var token = _a.token;
    return token.colorBorderSecondary;
});
var Buffer = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-direction: row;\n  gap: 4px;\n"], ["\n  flex-direction: row;\n  gap: 4px;\n"])));
var templateObject_1, templateObject_2;
